var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2046_55685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.304688 11.3612L19.751 0.416016L39.6738 11.3612V27.2285H0.544192L0.304688 11.3612Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.122195,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.547 3.36768H5.4375V29.2563H34.547V3.36768Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.122195,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76953 7.90039H30.8406",
    stroke: "#263238",
    strokeWidth: 0.122195,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76953 10.1665H30.8406",
    stroke: "#263238",
    strokeWidth: 0.122195,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76953 12.4355H30.8406",
    stroke: "#263238",
    strokeWidth: 0.122195,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76953 14.7012H30.8406",
    stroke: "#263238",
    strokeWidth: 0.122195,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76953 16.9673H30.8406",
    stroke: "#263238",
    strokeWidth: 0.122195,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76953 19.2344H30.8406",
    stroke: "#263238",
    strokeWidth: 0.122195,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6738 33.1948H0.304688V11.3618L19.9905 24.7241L39.6738 11.3618V33.1948Z",
    fill: "#3A3D4E",
    stroke: "#263238",
    strokeWidth: 0.122195,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.304688 33.1935L14.6187 21.0703",
    stroke: "#263238",
    strokeWidth: 0.122195,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6179 33.1925L25.4102 21.0498",
    stroke: "#263238",
    strokeWidth: 0.122195,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2046_55685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 33.4331,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/Envelope.aa31ad18cf6ec3e457fabd23051aa60e.svg";
export { ForwardRef as ReactComponent };